module.exports = __webpack_public_path__ + "static/img/gywm_gsjj_img_one.41f3662.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gywm_gsjj_img_one.png
// module id = Y9ck
// module chunks = 21